
import React, { useEffect, useState, useCallback } from "react";
import logo from "../../../../../../assets/img/logo.png";
import {
  FaArrowLeft,
  FaHistory,
  FaTimes,
  FaWallet,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { fetchwalletamount } from "../../../../../../common";
import { decryptData, encryptData } from "../../../../../../decryptHelper";
import BetHistory from "../../pages/BetHistory";

export default function Header({ navigate }) {
  const [balance, setBalance] = useState(0);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [walletAmount, setWalletAmount] = useState(null);

  // Fetch profile wallet balance
  const loadWallet = useCallback(async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const dev_id = localStorage.getItem("dev_id");

      if (!user_id || !dev_id) {
        console.log("userid or dev_id missing");
        return;
      }

      const apiUrl =
        "https://api.babaclubs.co/api/users/user-profile";

      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
        device_id: dev_id,
      };

      const encryptedText = encryptData(requestData);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: encryptedText,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data1 = await response.json();

      if (!data1?.encryptedResponse) {
        console.error("encryptedResponse not found");
        return;
      }

      const data = decryptData(data1.encryptedResponse);

      if (data?.success === "1" || data?.success === 1) {
        const credit = data?.data?.credit ?? 0;
        setBalance(Number(credit) || 0);
      } else {
        console.error("Profile API Error:", data?.message);
      }
    } catch (error) {
      console.error("Wallet Error:", error);
    }
  }, []);

  // Fetch wallet amount from common function
  const loadWalletAmount = useCallback(() => {
    try {
      fetchwalletamount(setWalletAmount);
    } catch (error) {
      console.error("Fetch wallet amount error:", error);
    }
  }, []);

  // Initial load and refresh every 5 seconds
  useEffect(() => {
    loadWallet();
    loadWalletAmount();

    const interval = setInterval(() => {
      loadWallet();
      loadWalletAmount();
    }, 5000);

    return () => clearInterval(interval);
  }, [loadWallet, loadWalletAmount]);

  // Format amount safely
  const formatAmount = (amount) => {
    const value =
      typeof amount === "object" && amount !== null
        ? amount.amount ?? amount.balance ?? amount.credit ?? 0
        : amount;

    const number = Number(value);

    return (Number.isFinite(number) ? number : 0).toLocaleString(
      "en-IN",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    );
  };

  return (
    <>
      <header className="topbar">
        <div className="lefTop_bar">
          <Link to="/" className="back_btn">
            <FaArrowLeft />
          </Link>

          <button
            className="aviator-logo"
            type="button"
          >
            Aviator
          </button>
        </div>

        <div className="auth-brand">
          <img src={logo} alt="logo" />
        </div>

        <div className="right_header">
          {/* Profile API balance */}
          {/* <div className="wallet_balance">
            <FaWallet />
            <b>
              ₹{formatAmount(balance)}
            </b>
          </div> */}

          {/* fetchwalletamount balance */}
          <div className="wallet_balance">
            <FaWallet />
            <b>
              ₹{formatAmount(walletAmount)}
            </b>
          </div>

          {/* Bet history */}
          <div
            className="history"
            title="Bet History"
            role="button"
            tabIndex={0}
            onClick={() => setShowHistoryModal(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setShowHistoryModal(true);
              }
            }}
          >
            <FaHistory />
          </div>
        </div>
      </header>

      {/* Bet History Modal */}
      {showHistoryModal && (
        <div
          className="aviator-history-overlay"
          onClick={() => setShowHistoryModal(false)}
        >
          <div
            className="aviator-history-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="aviator-history-close"
              onClick={() => setShowHistoryModal(false)}
              aria-label="Close Bet History"
            >
              <FaTimes />
            </button>

            <BetHistory />
          </div>
        </div>
      )}
    </>
  );
}
